module.exports = __webpack_public_path__ + "static/media/french-fries.e000d63b.svg";